// Exports:
export enum EXTENDED_MENU {
  ADD_AN_EXTENSION = 'ADD_AN_EXTENSION'
}
